import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Data,
  NavigationEnd,
  Router,
} from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { IBreadcrumbRoute } from '../entities/breadcrumb.model';

@Injectable({providedIn: 'root'})
export class BreadcrumbService {
  private readonly _breadcrumbs$ = new BehaviorSubject<IBreadcrumbRoute[]>([]);
  public readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor(private readonly router: Router) {
    const updateBreadcrumb = () => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs: IBreadcrumbRoute[] = [];
      const breadcrumbsByRoute: Record<string, IBreadcrumbRoute> = {}
      this.addBreadcrumb(root, [], breadcrumbs, breadcrumbsByRoute);

      this._breadcrumbs$.next(breadcrumbs);
    };
    updateBreadcrumb();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        updateBreadcrumb();
      });
  }

  private addBreadcrumb(
    route: ActivatedRouteSnapshot | null,
    parentUrl: string[],
    breadcrumbs: IBreadcrumbRoute[],
    breadcrumbsByRoute: Record<string, IBreadcrumbRoute>
  ) {
    if (route) {
      const routeUrl = parentUrl.concat(route.url.map((url) => url.path));
      const breadcrumbData = this.getData(route?.routeConfig?.data);

      const url = '/' + routeUrl.join('/');
      if (breadcrumbData && !breadcrumbsByRoute[url]) {

        const { label, icon, canFavorite } = breadcrumbData;
        const breadcrumb = {
          label,
          icon,
          canFavorite,
          favorite: false,
          url,
        };
        breadcrumbsByRoute[url] = breadcrumb;
        breadcrumbs.push(breadcrumb);
      }

      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs, breadcrumbsByRoute);
    }
  }

  private getData(data: Data) {
    return typeof data?.['breadcrumb'] === 'function'
      ? data?.['breadcrumb']?.(data)
      : data?.['breadcrumb'];
  }
}
